'use client';

import type { FC } from 'react';
import { Button } from '../../ui';
import { useLocalTranslation } from '../../../hooks/useLocalTranslation';
import translations from './RushMid.translations';

export const LobbyUpdateNotice: FC = () => {
  const { t } = useLocalTranslation(translations);
  return (
    <div className="flex flex-col items-stretch gap-2">
      <div className="rounded-xl border border-side-t/30 bg-side-t/10 px-4 py-2 text-center text-sm font-semibold text-side-t">
        {t('updateBanner')}
      </div>
      <Button variant="primary" size="l" stretched data-sound="cta" onClick={() => window.location.reload()}>
        {t('updateNow')}
      </Button>
    </div>
  );
};
